import { render } from "./AnnouncementManagement.vue?vue&type=template&id=ebb25430&scoped=true"
import script from "./AnnouncementManagement.vue?vue&type=script&lang=js"
export * from "./AnnouncementManagement.vue?vue&type=script&lang=js"

import "./AnnouncementManagement.vue?vue&type=style&index=0&id=ebb25430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb25430"]])

export default __exports__